var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tabbed-menu",
    {
      attrs: {
        "initial-tab": _vm.initialTab,
        tabs: [
          {
            name: _vm.tabs.touchpointStatistics,
            label: this.resource(
              "JourneyBuilder_TouchpointOverview_Tab_Statistics"
            ),
            isDisabled: _vm.disableStatistics
          },
          {
            name: _vm.tabs.touchpointInfo,
            label: this.resource("JourneyBuilder_TouchpointOverview_Tab_Info")
          }
        ]
      }
    },
    [
      _c(
        "template",
        { slot: _vm.tabs.touchpointStatistics },
        [
          _c("touchpoint-statistics", {
            staticClass: "tab-pane show active",
            attrs: { role: "tabpanel", "brick-id": _vm.brickId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: _vm.tabs.touchpointInfo },
        [
          _c("touchpoint-info", {
            staticClass: "tab-pane show active",
            attrs: {
              role: "tabpanel",
              name: _vm.name,
              type: _vm.type,
              config: _vm.config,
              "incoming-connections-info": _vm.incomingConnectionsInfo,
              "outgoing-connections-info": _vm.outgoingConnectionsInfo
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }